module.exports = __webpack_public_path__ + "static/media/vit.7d75f437.png";